import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateDelegationValidity } from "../../api/delegation";
import { UpdateDelegationValidityModel } from "../../interfaces/delegation";
import { invalidateDelegationQueries } from "./delegationQueryKeys";

export const useUpdateDelegationValidity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      model,
    }: {
      id: string;
      model: UpdateDelegationValidityModel;
    }) => updateDelegationValidity(id, model),
    onSuccess: () => {
      invalidateDelegationQueries(queryClient);
    },
  });
};
